<app-breadcrumb [title]="'Riesgos Viales'" [items]="['PESV', 'Riesgos Viales']" [active_item]="'Riesgos Viales'">
</app-breadcrumb>
<div class="container-fluid">
    <div class="card">
                <div class="card-body">


            <ul ngbNav #nav="ngbNav" class="nav-tabs" [(activeId)]="tabActiva">
                <li [ngbNavItem]="1">
                    <a ngbNavLink><strong>REGISTRO DE RIESGOS</strong></a>
                    <ng-template ngbNavContent>
                        <form [formGroup]="form" (ngSubmit)="guardar()" novalidate>
                           <div class="card border-0 shadow-sm mt-4">
                              
                                <div class="card-header bg-primary text-white">
                                  <div class="d-flex align-items-center">
                                    <i class="bi bi-people-fill fs-4 me-2"></i>
                                    <div>
                                      <h6 class="mb-0 fw-bold">Datos Básicos</h6>
                                     <!--  <small>Ingrese el número de personas por categoría</small> -->
                                    </div>
                                  </div>
                                </div>
                              
                                <div class="card-body">
                              
                                  <div class="row g-4">
                               <div class="col-md-3">
                                    <label class="form-label"><strong>CONSECUTIVO:</strong></label>
                                    <input type="text" class="form-control" formControlName="consecutivo">
                                </div>
                                <div class="col-md-3">
                                    <label class="form-label"><strong>PROCESO:</strong><a
                                            class="text-danger">*</a></label>
                                  <input type="text" class="form-control" formControlName="proceso"
                                    [ngClass]="{ 'is-invalid': form.get('proceso')?.touched && form.get('proceso')?.invalid }"> 

                                </div>
                                <div class="col-md-3">
                                    <label class="form-label"><strong>AREA:</strong><a
                                            class="text-danger">*</a></label>
                                  <input type="text" class="form-control" formControlName="area"
                                    [ngClass]="{ 'is-invalid': form.get('area')?.touched && form.get('area')?.invalid }">

                                </div>
                                    <div class="col-md-3">
                                    <label class="form-label"><strong>ACTIVIDAD:</strong><a
                                            class="text-danger">*</a></label>
                                    <input type="text" class="form-control" formControlName="actividad" >
                                           
                                </div>
                                <div class="col-md-3">
                                  <label class="form-label"><strong>ROL EN LA VIA:</strong><a class="text-danger">*</a></label>
                                  <ng-select [items]="listaActorvial" bindLabel="descripcion" bindValue="id" placeholder="Seleccione actor vial"
                                    formControlName="actor_vial"
                                    [ngClass]="{ 'is-invalid': form.get('actor_vial')?.touched && form.get('actor_vial')?.invalid }">
                                  </ng-select>
                                  <div class="invalid-feedback" *ngIf="form.get('actor_vial')?.touched && form.get('actor_vial')?.invalid">
                                    El actor vial es obligatorio.
                                  </div>
                                </div>
                                                             
                                <div class="col-md-3">
                                  <label class="form-label"><strong>TIPO DE VEHÍCULO:</strong><a class="text-danger">*</a> </label>
                                  <ng-select [items]="tiposVehiculo" bindLabel="tipos" bindValue="idTipos"
                                    placeholder="Seleccione tipo de vehículo" formControlName="tipo_vehiculo"
                                    [ngClass]="{ 'is-invalid': form.get('tipo_vehiculo')?.touched && form.get('tipo_vehiculo')?.invalid }">
                                    <ng-template ng-label-tmp let-item="item">
                                      <span class="text-uppercase">
                                        {{ item.tipos }}
                                      </span>
                                    </ng-template>
                                  </ng-select>
                                </div>
                                  <div class="col-md-3">
                                    <label class="form-label"><strong>CANTIDAD DE VEHÍCULOS:</strong><a
                                            class="text-danger">*</a></label>
                                    <input type="number" min="1" class="form-control" formControlName="cantidadVehiculos" >
                                           
                                </div>
                               <div class="col-md-3">
                                    <label class="form-label"><strong>CLASIFICACIÓN DE VARIABLES DE RIESGOS:</strong><a
                                            class="text-danger">*</a></label>
                                    <ng-select [items]="categoriasRiesgoVial" bindLabel="nombre_categoria"
                                        bindValue="id" placeholder="Seleccione categoría vial"
                                        formControlName="categoria_riesgo_vial" (change)="onCategoriaChange()"
                                        [ngClass]="{ 'is-invalid': form.get('categoria_riesgo_vial')?.touched && form.get('categoria_riesgo_vial')?.invalid }">
                                    </ng-select>
                                    <div class="invalid-feedback"
                                        *ngIf="form.get('categoria_riesgo_vial')?.touched && form.get('categoria_riesgo_vial')?.invalid">
                                        La categoría vial es obligatoria.
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <label class="form-label"><strong>TIPO DE RIESGO:</strong><a
                                            class="text-danger">*</a></label>
                                    <ng-select [items]="tiposRiesgoVialFiltrados" bindLabel="descripcion" bindValue="id"
                                        placeholder="Seleccione tipo de riesgo" formControlName="tipo_riesgo"
                                        [disabled]="!form.get('categoria_riesgo_vial')?.value"
                                        [ngClass]="{ 'is-invalid': form.get('tipo_riesgo')?.touched && form.get('tipo_riesgo')?.invalid }">
                                    </ng-select>
                                    <div class="invalid-feedback"
                                        *ngIf="form.get('tipo_riesgo')?.touched && form.get('tipo_riesgo')?.invalid">
                                        El tipo de riesgo es obligatorio.
                                    </div>
                                </div>
                              
                                  </div>
                              
                                </div>
                              
                              
                               </div>
                               
                              
                                
                               
                              <div class="card border-0 shadow-sm mt-4">
                              
                                <div class="card-header bg-primary text-white">
                                  <div class="d-flex align-items-center">
                                    <i class="bi bi-people-fill fs-4 me-2"></i>
                                    <div>
                                      <h6 class="mb-0 fw-bold">Cantidad de Personas Expuestas</h6>
                                     
                                    </div>
                                  </div>
                                </div>
                              
                                <div class="card-body">
                              
                                  <div class="row g-4">
                              
                                    <!-- Directos -->
                                    <div class="col-xl-3 col-lg-6">
                              
                                      <div class="border rounded-3 p-3 h-100">
                              
                                        <div class="text-center mb-3">
                                          <i class="bi bi-person-badge fs-2 text-primary"></i>
                                        </div>
                              
                                        <label class="form-label fw-semibold">
                                          EMPLEADOS DIRECTOS
                                          <span class="text-danger">*</span>
                                        </label>
                              
                                        <div class="input-group">
                              
                                          <input type="number" min="0" placeholder="0" class="form-control text-center fw-bold fs-5"
                                            formControlName="empleados_directos">
                              
                                          <span class="input-group-text">
                                            Personas
                                          </span>
                              
                                        </div>
                              
                                      </div>
                              
                                    </div>
                              
                                    <!-- Misionales -->
                                    <div class="col-xl-3 col-lg-6">
                              
                                      <div class="border rounded-3 p-3 h-100">
                              
                                        <div class="text-center mb-3">
                                          <i class="bi bi-person-workspace fs-2 text-success"></i>
                                        </div>
                              
                                        <label class="form-label fw-semibold">
                                          EMPLEADOS MISIONALES
                                          <span class="text-danger">*</span>
                                        </label>
                              
                                        <div class="input-group">
                              
                                          <input type="number" min="0" placeholder="0" class="form-control text-center fw-bold fs-5"
                                            formControlName="empleados_misionales">
                              
                                          <span class="input-group-text">
                                            Personas
                                          </span>
                              
                                        </div>
                              
                                      </div>
                              
                                    </div>
                              
                                    <!-- Contratistas -->
                                    <div class="col-xl-3 col-lg-6">
                              
                                      <div class="border rounded-3 p-3 h-100">
                              
                                        <div class="text-center mb-3">
                                          <i class="bi bi-briefcase-fill fs-2 text-warning"></i>
                                        </div>
                              
                                        <label class="form-label fw-semibold">
                                          CONTRATISTAS
                                          <span class="text-danger">*</span>
                                        </label>
                              
                                        <div class="input-group">
                              
                                          <input type="number" min="0" placeholder="0" class="form-control text-center fw-bold fs-5"
                                            formControlName="contratistas">
                              
                                          <span class="input-group-text">
                                            Personas
                                          </span>
                              
                                        </div>
                              
                                      </div>
                              
                                    </div>
                              
                                    <!-- Visitantes -->
                                    <div class="col-xl-3 col-lg-6">
                              
                                      <div class="border rounded-3 p-3 h-100">
                              
                                        <div class="text-center mb-3">
                                          <i class="bi bi-person-fill fs-2 text-info"></i>
                                        </div>
                              
                                        <label class="form-label fw-semibold">
                                          VISITANTES
                                          <span class="text-danger">*</span>
                                        </label>
                              
                                        <div class="input-group">
                              
                                          <input type="number" min="0" placeholder="0" class="form-control text-center fw-bold fs-5"
                                            formControlName="visitantes">
                              
                                          <span class="input-group-text">
                                            Personas
                                          </span>
                              
                                        </div>
                              
                                      </div>
                              
                                    </div>
                              
                                  </div>
                              
                                </div>
                              
                              </div>

                              <div class="card border-0 shadow-sm mt-2">
                              
                                <div class="card-header bg-primary text-white">
                                  <div class="d-flex align-items-center">
                                    <i class="bi bi-people-fill fs-4 me-2"></i>
                                    <div>
                                      <h6 class="mb-0 fw-bold">Clasificación de la Ruta</h6>                                     
                                    </div>
                                  </div>
                                </div>
                              
                                <div class="card-body">
                              
                                  <div class="row g-4">
                             <!--  <div class="col-md-3">
                                <label class="form-label"><strong>ORIGEN:</strong><a class="text-danger">*</a></label>
                                <ng-select [items]="municipios" bindLabel="MUNICIPIO" bindValue="IDMUN" placeholder="Selecciona una ciudad de origen"
                                  formControlName="origen" [ngClass]="{ 'is-invalid': form.get('origen')?.touched && form.get('origen')?.invalid }">
                                  <ng-template ng-label-tmp let-item="item">
                                    <span class="text-uppercase">
                                      {{ item.MUNICIPIO }} ({{ item.departamento?.nombre }})
                                    </span>
                                  </ng-template>
                                  <ng-template ng-option-tmp let-item="item">
                                    <span class="text-uppercase">
                                      {{ item.MUNICIPIO }} ({{ item.departamento?.nombre }})
                                    </span>
                                  </ng-template>
                                </ng-select>
                                <div class="invalid-feedback" *ngIf="form.get('origen')?.touched && form.get('origen')?.invalid">
                                  La ciudad de origen es obligatoria.
                                </div>
                              </div>
                              <div class="col-md-3">
                                <label class="form-label"><strong>DESTINO:</strong><a class="text-danger">*</a></label>
                                <ng-select [items]="municipios" bindLabel="MUNICIPIO" bindValue="IDMUN" placeholder="Selecciona una ciudad de destino"
                                  formControlName="destino"
                                  [ngClass]="{ 'is-invalid': form.get('destino')?.touched && form.get('destino')?.invalid }">
                                  <ng-template ng-label-tmp let-item="item">
                                    <span class="text-uppercase">
                                      {{ item.MUNICIPIO }} ({{ item.departamento?.nombre }})
                                    </span>
                                  </ng-template>
                                  <ng-template ng-option-tmp let-item="item">
                                    <span class="text-uppercase">
                                      {{ item.MUNICIPIO }} ({{ item.departamento?.nombre }})
                                    </span>
                                  </ng-template>
                                </ng-select>
                                <div class="invalid-feedback" *ngIf="form.get('destino')?.touched && form.get('destino')?.invalid">
                                  La ciudad de destino es obligatoria.
                                </div>
                              </div> -->
                            <!--   <div class="col-md-3">
                                <label class="form-label"><strong>FECHA:</strong><a class="text-danger">*</a></label>
                                <input type="date" class="form-control" formControlName="fecha" [max]="maxFecha" required />
                                <div class="invalid-feedback" *ngIf="form.get('fecha')?.hasError('required')">
                                  La fecha es obligatoria.
                                </div>
                                <div class="invalid-feedback" *ngIf="form.get('fecha')?.hasError('fechaFutura')">
                                  La fecha no puede ser en el futuro.
                                </div>
                              </div> -->
                              <div class="col-md-6">
                                <label class="form-label"><strong>NIVEL DE EXPOSICIÓN:</strong><a class="text-danger">*</a></label>
                                <ng-select [items]="nivelesExposicion" bindLabel="descripcion" bindValue="id"
                                  placeholder="Seleccione nivel de exposición" formControlName="nivel_exposicion"
                                  [ngClass]="{ 'is-invalid': form.get('nivel_exposicion')?.touched && form.get('nivel_exposicion')?.invalid }">
                                </ng-select>
                                <div class="invalid-feedback" *ngIf="form.get('nivel_exposicion')?.touched && form.get('nivel_exposicion')?.invalid">
                                  El nivel de exposición es obligatorio.
                                </div>
                              </div>
                                <div class="col-md-6">
                                  <label class="form-label"><strong>NIVEL DE PROBABILIDAD:</strong><a class="text-danger">*</a></label>
                                  <ng-select [items]="nivelesProbabilidad" bindLabel="descripcion" bindValue="id"
                                    placeholder="Seleccione nivel de probabilidad" formControlName="nivel_probabilidad"
                                    [ngClass]="{ 'is-invalid': form.get('nivel_probabilidad')?.touched && form.get('nivel_probabilidad')?.invalid }">
                                  </ng-select>
                                  <div class="invalid-feedback"
                                    *ngIf="form.get('nivel_probabilidad')?.touched && form.get('nivel_probabilidad')?.invalid">
                                    El nivel de probabilidad es obligatorio.
                                  </div>
                                </div>
                                <div class="col-md-12">
                                  <label class="form-label"><strong>DESCRIPCIÓN:</strong></label>
                                  <textarea class="form-control" formControlName="descripcion" rows="2"
                                    placeholder="Describa el riesgo identificado"></textarea>
                                </div>
                                </div>
                                
                                </div>
                              
                              </div>
                               

                             
                          
                               
                           
                            <div class="d-flex justify-content-center gap-2">
                                <button type="button" class="btn btn-light" (click)="cancelar()"
                                    *ngIf="editando">Cancelar</button>
                                <button type="submit" class="btn btn-primary" [disabled]="form.invalid || guardando">
                                    {{ guardando ? 'Guardando...' : (editando ? 'Actualizar' : 'Guardar') }}
                                </button>
                            </div>
                        </form>
                    </ng-template>
                </li>
                <li [ngbNavItem]="2">
                    <a ngbNavLink><strong>LISTADO DE RIESGOS</strong></a>
                    <ng-template ngbNavContent>
                        <!-- Buscador y filtro de estado -->
                        <div class="row mb-3">
                            <div class="col-md-3">
                                <select class="form-select" [(ngModel)]="filtroEstado" (change)="aplicarFiltro()">
                                    <option [ngValue]="null">Todos</option>
                                    <option [ngValue]="1">Activos</option>
                                    <option [ngValue]="0">Inactivos</option>
                                </select>
                            </div>
                            <div class="col-md-4 ms-auto">
                                <div class="input-group">
                                    <input type="text" class="form-control"
                                        placeholder="Buscar por actor vial, tipo de riesgo, actividad..."
                                        [(ngModel)]="filtro" (input)="aplicarFiltro()" />
                                    <span class="input-group-text">
                                        <i class="fa fa-search"></i>
                                    </span>
                                </div>
                            </div>
                        </div>

                            <div class="card border-0 shadow-sm mb-4 col-md-12">
                              <div class="card-header bg-primary d-flex justify-content-between align-items-center">
                                <h6 class="mb-0 fw-bold text-white">Distribución de Riesgos por Clasificación</h6>
                                <span class="badge bg-light">Total: {{ totalRiesgosGrafico }}</span>
                              </div>
                              <div class="card-body">
                                <div *ngIf="totalRiesgosGrafico > 0; else sinDatosGrafico" class="riesgos-chart-wrap">
                                  <apx-chart [series]="graficoRiesgosClasificacion.series"
                                    [chart]="graficoRiesgosClasificacion.chart"
                                    [plotOptions]="graficoRiesgosClasificacion.plotOptions"
                                    [colors]="graficoRiesgosClasificacion.colors"
                                    [dataLabels]="graficoRiesgosClasificacion.dataLabels"
                                    [xaxis]="graficoRiesgosClasificacion.xaxis"
                                    [yaxis]="graficoRiesgosClasificacion.yaxis"
                                    [grid]="graficoRiesgosClasificacion.grid"
                                    [legend]="graficoRiesgosClasificacion.legend"
                                    [tooltip]="graficoRiesgosClasificacion.tooltip">
                                  </apx-chart>
                                </div>
                                <ng-template #sinDatosGrafico>
                                  <div class="text-center text-muted py-4">
                                    No hay datos para graficar con los filtros actuales.
                                  </div>
                                </ng-template>
                              </div>
                            </div>

                        <div class="table-responsive mt-4">
                            <table id="riesgosTable" class="table table-bordered table-hover">
                                <thead class="bg-primary text-white">
                                    <tr>
                                      <th style="cursor: pointer" (click)="sortData('fecha')">
                                            <strong>FECHA</strong>
                                            <i class="fa ms-1" [ngClass]="{
                        'fa-sort-up': sortColumn === 'fecha' && sortDirection === 'asc',
                        'fa-sort-down': sortColumn === 'fecha' && sortDirection === 'desc',
                        'fa-sort': sortColumn !== 'fecha'
                      }"></i>
                                        </th>
                                        <th style="cursor: pointer" (click)="sortData('consecutivo')">
                                            <strong>CONSECUTIVO</strong>
                                            <i class="fa ms-1" [ngClass]="{
                        'fa-sort-up': sortColumn === 'consecutivo' && sortDirection === 'asc',
                        'fa-sort-down': sortColumn === 'consecutivo' && sortDirection === 'desc',
                        'fa-sort': sortColumn !== 'consecutivo'
                      }"></i>
                                        </th>
                                        <th style="cursor: pointer" (click)="sortData('actor_vial')">
                                            <strong>ACTOR VIAL</strong>
                                            <i class="fa ms-1" [ngClass]="{
                        'fa-sort-up': sortColumn === 'actor_vial' && sortDirection === 'asc',
                        'fa-sort-down': sortColumn === 'actor_vial' && sortDirection === 'desc',
                        'fa-sort': sortColumn !== 'actor_vial'
                      }"></i>
                                        </th>
                                        <th style="cursor: pointer" (click)="sortData('tipo_riesgo')">
                                            <strong>TIPO RIESGO</strong>
                                            <i class="fa ms-1" [ngClass]="{
                        'fa-sort-up': sortColumn === 'tipo_riesgo' && sortDirection === 'asc',
                        'fa-sort-down': sortColumn === 'tipo_riesgo' && sortDirection === 'desc',
                        'fa-sort': sortColumn !== 'tipo_riesgo'
                      }"></i>
                                        </th>
                                        <th style="cursor: pointer" (click)="sortData('actividad')">
                                            <strong>ACTIVIDAD</strong>
                                            <i class="fa ms-1" [ngClass]="{
                        'fa-sort-up': sortColumn === 'actividad' && sortDirection === 'asc',
                        'fa-sort-down': sortColumn === 'actividad' && sortDirection === 'desc',
                        'fa-sort': sortColumn !== 'actividad'
                      }"></i>
                                        </th>
                                        
                                        <th style="cursor: pointer" (click)="sortData('nivel_exposicion')">
                                            <strong>NIVEL EXPOSICIÓN</strong>
                                            <i class="fa ms-1" [ngClass]="{
                        'fa-sort-up': sortColumn === 'nivel_exposicion' && sortDirection === 'asc',
                        'fa-sort-down': sortColumn === 'nivel_exposicion' && sortDirection === 'desc',
                        'fa-sort': sortColumn !== 'nivel_exposicion'
                      }"></i>
                                        </th>
                                        <th style="cursor: pointer" (click)="sortData('nivel_probabilidad')">
                                            <strong>NIVEL PROBABILIDAD</strong>
                                            <i class="fa ms-1" [ngClass]="{
                        'fa-sort-up': sortColumn === 'nivel_probabilidad' && sortDirection === 'asc',
                        'fa-sort-down': sortColumn === 'nivel_probabilidad' && sortDirection === 'desc',
                        'fa-sort': sortColumn !== 'nivel_probabilidad'
                      }"></i>
                                        </th>
                                        <!-- <th style="cursor: pointer" (click)="sortData('nivel_riesgo')">
                                            <strong>NIVEL RIESGO</strong>
                                            <i class="fa ms-1" [ngClass]="{
                        'fa-sort-up': sortColumn === 'nivel_riesgo' && sortDirection === 'asc',
                        'fa-sort-down': sortColumn === 'nivel_riesgo' && sortDirection === 'desc',
                        'fa-sort': sortColumn !== 'nivel_riesgo'
                      }"></i>
                                        </th> -->
                                        <th style="cursor: pointer" (click)="sortData('clasificacion')">
                                            <strong>CLASIFICACIÓN</strong>
                                            <i class="fa ms-1" [ngClass]="{
                        'fa-sort-up': sortColumn === 'clasificacion' && sortDirection === 'asc',
                        'fa-sort-down': sortColumn === 'clasificacion' && sortDirection === 'desc',
                        'fa-sort': sortColumn !== 'clasificacion'
                      }"></i>
                                        </th>
                                        <th style="cursor: pointer" (click)="sortData('estado')">
                                            <strong>ESTADO</strong>
                                            <i class="fa ms-1" [ngClass]="{
                        'fa-sort-up': sortColumn === 'estado' && sortDirection === 'asc',
                        'fa-sort-down': sortColumn === 'estado' && sortDirection === 'desc',
                        'fa-sort': sortColumn !== 'estado'
                      }"></i>
                                        </th>
                                        <th>ACCIONES</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        *ngFor="let r of riesgosFiltrados | paginate: { itemsPerPage: pageSize, currentPage: page }; let i = index">
                                        <td>{{ r.fecha_creacion | date:'dd/MM/yyyy' }}</td>
                                        <td>{{ getActorVialLabel(r.consecutivo) }}</td>
                                        <td>{{ getActorVialLabel(r.tipoActorVialData.descripcion) }}</td>
                                        <td>{{ getTipoRiesgoLabel(r.tipo_riesgo) }}</td>
                                        <td>{{ r.actividad }}</td>                                      
                                        <td  data-bs-toggle="tooltip"   data-bs-placement="top"  [attr.title]="r.nivelExposicionData.descripcion">{{ r.nivelExposicionData.nivel }} ({{ r.nivelExposicionData.id }})</td>
                                         <td class="text-center">{{ r.nivelProbabilidadData.nivel }} ({{ r.nivelProbabilidadData.id }})</td>
                                        <!-- <td class="text-center">{{  r.nivelExposicionData.id * r.nivelProbabilidadData.id }}</td> -->
                                        <td>
                                            <span [ngStyle]="{'color': r.color, 'font-weight': 'bold'}"> {{  r.nivelExposicionData.id * r.nivelProbabilidadData.id }} - {{r.clasificacion }}</span>
                                        </td>
                                        <td>
                                            <span class="badge"
                                                [ngClass]="r.estado === 1 ? 'bg-success' : 'bg-secondary'">
                                                {{ r.estado === 1 ? 'Activo' : 'Inactivo' }}
                                            </span>
                                        </td>
                                        
                                        <td class="text-center">
                                        
                                          <div class="d-flex justify-content-center gap-1">
                                        
                                            <button class="btn btn-sm btn-outline-success rounded-pill btn-rounded" ngbTooltip="Editar"
                                              (click)="editarRiesgo(r)">
                                              <i class="icofont icofont-edit"></i>
                                            </button>
                                        
                                            <button class="btn btn-sm btn-outline-danger rounded-pill btn-rounded" ngbTooltip="Inactivar"
                                              (click)="inactivarLiderazgoDesdeHistorial(acta)">
                                              <i class="icofont icofont-trash"></i>
                                            </button>
                                        
                                            <button class="btn btn-sm btn-outline-danger rounded-pill btn-rounded" ngbTooltip="Plan de acción"
                                              (click)="CrearPlanAccion(r.id!)">
                                              <i class="icofont icofont-check-circled"></i>
                                            </button>
                                        
                                        
                                          </div>
                                        
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <tr *ngIf="!riesgosFiltrados.length">
                                <td colspan="12" class="text-center">No hay registros.</td>
                            </tr>
                            <div class="d-flex justify-content-between align-items-center mt-4" *ngIf="!cargando">
                                <div class="d-flex align-items-center">
                                    <label for="pageSizeRiesgos" class="me-2">Mostrar:</label>
                                    <select id="pageSizeRiesgos" class="form-select w-auto" [(ngModel)]="pageSize"
                                        (change)="page = 1">
                                        <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}
                                        </option>
                                    </select>
                                    <span class="ms-2">registros por página</span>
                                </div>
                                <div class="text-center flex-grow-1">
                                    Total Registros:
                                    <a class="badge badge-primary"><b>{{ riesgosFiltrados?.length || 0 }}</b></a>
                                </div>
                                <div class="text-end paginador-personalizado">
                                    <pagination-controls (pageChange)="page = $event" [maxSize]="5"
                                        [directionLinks]="true" [autoHide]="true" previousLabel="Anterior"
                                        nextLabel="Siguiente">
                                    </pagination-controls>
                                </div>
                            </div>
                            <div class="mt-4">
                                <div class="btn-showcase text-center">
                                    <button class="btn btn-outline-success-2x" type="button" placement="top"
                                        ngbTooltip="Exportar a Excel"
                                        (click)="exportarExcel('riesgosTable','Listado_Riesgos_Viales')">
                                        <i class="icofont icofont-file-excel"></i> EXCEL
                                    </button>

                                    <button class="btn btn-outline-danger-2x" type="button" placement="top"
                                        ngbTooltip="Exportar a PDF"
                                        (click)="exportToPDF('riesgosTable','Listado_Riesgos_Viales','Listado de Riesgos Viales')">
                                        <i class="icofont icofont-file-pdf"></i> PDF
                                    </button>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </li>

               
            </ul>
            <div [ngbNavOutlet]="nav" class="mt-2"></div>
        </div>
    </div>
</div>


<ng-template #modalEditarRiesgo let-modal>
    <div class="card border-4 rounded-3">
        <form [formGroup]="form">
            <div
                class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
                <h5 class="mb-0"><strong>EDITAR RIESGO VIAL</strong></h5>
                <button type="button" class="btn-close btn-close-white" aria-label="Close"
                    (click)="cerrarModal(modal)"></button>
            </div>
            <div class="card-body">
                <div class="row g-3 mb-3">
                    <div class="col-md-4">
                        <label class="form-label"><strong>Actor Vial:</strong><a class="text-danger">*</a></label>
                        <ng-select [items]="rolesVia" bindLabel="descripcionRolVia" bindValue="idRolVia"
                            placeholder="Seleccione actor vial" formControlName="actor_vial"
                            [ngClass]="{ 'is-invalid': form.get('actor_vial')?.touched && form.get('actor_vial')?.invalid }">
                        </ng-select>
                        <div class="invalid-feedback"
                            *ngIf="form.get('actor_vial')?.touched && form.get('actor_vial')?.invalid">
                            El actor vial es obligatorio.
                        </div>
                    </div>
                    <div class="col-md-4">
                        <label class="form-label"><strong>CLASIFICACIÓN DE VARIABLE DE RIESGOS:</strong><a class="text-danger">*</a></label>
                        <ng-select [items]="categoriasRiesgoVial" bindLabel="nombre_categoria" bindValue="id"
                            placeholder="Seleccione categoría vial" formControlName="categoria_riesgo_vial"
                            (change)="onCategoriaChange()"
                            [ngClass]="{ 'is-invalid': form.get('categoria_riesgo_vial')?.touched && form.get('categoria_riesgo_vial')?.invalid }">
                        </ng-select>
                        <div class="invalid-feedback"
                            *ngIf="form.get('categoria_riesgo_vial')?.touched && form.get('categoria_riesgo_vial')?.invalid">
                            La categoría vial es obligatoria.
                        </div>
                    </div>
                    <div class="col-md-4">
                        <label class="form-label"><strong>Tipo de Riesgo:</strong><a class="text-danger">*</a></label>
                        <ng-select [items]="tiposRiesgoVialFiltrados" bindLabel="descripcion" bindValue="id"
                            placeholder="Seleccione tipo de riesgo" formControlName="tipo_riesgo"
                            [disabled]="!form.get('categoria_riesgo_vial')?.value"
                            [ngClass]="{ 'is-invalid': form.get('tipo_riesgo')?.touched && form.get('tipo_riesgo')?.invalid }">
                        </ng-select>
                        <small class="text-danger d-block mt-1" *ngIf="!form.get('categoria_riesgo_vial')?.value">
                            Selecciona una categoría para mostrar el tipo de riesgo.
                        </small>
                        <div class="invalid-feedback"
                            *ngIf="form.get('tipo_riesgo')?.touched && form.get('tipo_riesgo')?.invalid">
                            El tipo de riesgo es obligatorio.
                        </div>
                    </div>
                    <div class="col-md-4">
                        <label class="form-label"><strong>Actividad:</strong><a class="text-danger">*</a></label>
                        <select class="form-select" formControlName="actividad" required>
                            <option value="RUTINARIA">RUTINARIA</option>
                            <option value="NO_RUTINARIA">NO RUTINARIA</option>
                        </select>
                    </div>
                    <div class="col-md-4">
                        <label class="form-label"><strong>Origen:</strong><a class="text-danger">*</a></label>
                        <ng-select [items]="municipios" bindLabel="MUNICIPIO" bindValue="IDMUN"
                            placeholder="Selecciona una ciudad de origen" formControlName="origen"
                            [ngClass]="{ 'is-invalid': form.get('origen')?.touched && form.get('origen')?.invalid }">
                            <ng-template ng-label-tmp let-item="item">
                                <span class="text-uppercase">
                                    {{ item.MUNICIPIO }} ({{ item.departamento?.nombre }})
                                </span>
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item">
                                <span class="text-uppercase">
                                    {{ item.MUNICIPIO }} ({{ item.departamento?.nombre }})
                                </span>
                            </ng-template>
                        </ng-select>
                        <div class="invalid-feedback"
                            *ngIf="form.get('origen')?.touched && form.get('origen')?.invalid">
                            La ciudad de origen es obligatoria.
                        </div>
                    </div>
                    <div class="col-md-4">
                        <label class="form-label"><strong>Destino:</strong><a class="text-danger">*</a></label>
                        <ng-select [items]="municipios" bindLabel="MUNICIPIO" bindValue="IDMUN"
                            placeholder="Selecciona una ciudad de destino" formControlName="destino"
                            [ngClass]="{ 'is-invalid': form.get('destino')?.touched && form.get('destino')?.invalid }">
                            <ng-template ng-label-tmp let-item="item">
                                <span class="text-uppercase">
                                    {{ item.MUNICIPIO }} ({{ item.departamento?.nombre }})
                                </span>
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item">
                                <span class="text-uppercase">
                                    {{ item.MUNICIPIO }} ({{ item.departamento?.nombre }})
                                </span>
                            </ng-template>
                        </ng-select>
                        <div class="invalid-feedback"
                            *ngIf="form.get('destino')?.touched && form.get('destino')?.invalid">
                            La ciudad de destino es obligatoria.
                        </div>
                    </div>
                   <!--  <div class="col-md-4">
                        <label class="form-label"><strong>Fecha:</strong><a class="text-danger">*</a></label>
                        <input type="date" class="form-control" formControlName="fecha" [max]="maxFecha" required />
                        <div class="invalid-feedback" *ngIf="form.get('fecha')?.hasError('required')">
                            La fecha es obligatoria.
                        </div>
                        <div class="invalid-feedback" *ngIf="form.get('fecha')?.hasError('fechaFutura')">
                            La fecha no puede ser en el futuro.
                        </div>
                    </div> -->
                    <div class="col-md-4">
                        <label class="form-label"><strong>Nivel Exposición:</strong><a class="text-danger">*</a></label>
                        <ng-select [items]="nivelesExposicion" bindLabel="descripcion" bindValue="id"
                            placeholder="Seleccione nivel de exposición" formControlName="nivel_exposicion"
                            [ngClass]="{ 'is-invalid': form.get('nivel_exposicion')?.touched && form.get('nivel_exposicion')?.invalid }">
                        </ng-select>
                        <div class="invalid-feedback"
                            *ngIf="form.get('nivel_exposicion')?.touched && form.get('nivel_exposicion')?.invalid">
                            El nivel de exposición es obligatorio.
                        </div>
                    </div>
                    <div class="col-md-4">
                        <label class="form-label"><strong>Nivel Probabilidad:</strong><a
                                class="text-danger">*</a></label>
                        <ng-select [items]="nivelesProbabilidad" bindLabel="descripcion" bindValue="id"
                            placeholder="Seleccione nivel de probabilidad" formControlName="nivel_probabilidad"
                            [ngClass]="{ 'is-invalid': form.get('nivel_probabilidad')?.touched && form.get('nivel_probabilidad')?.invalid }">
                        </ng-select>
                        <div class="invalid-feedback"
                            *ngIf="form.get('nivel_probabilidad')?.touched && form.get('nivel_probabilidad')?.invalid">
                            El nivel de probabilidad es obligatorio.
                        </div>
                    </div>
                    <div class="col-md-12">
                        <label class="form-label"><strong>Descripción:</strong></label>
                        <textarea class="form-control" formControlName="descripcion" rows="2"
                            placeholder="Describa el riesgo identificado"></textarea>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary" (click)="guardar()" [disabled]="form.invalid || guardando">
                    Actualizar
                </button>
                <button class="btn btn-secondary" (click)="cerrarModal(modal)">
                    Cancelar
                </button>
            </div>
        </form>
    </div>
</ng-template>